import { render } from "./OptionsContainer.vue?vue&type=template&id=6c2ad046&scoped=true"
import script from "./OptionsContainer.vue?vue&type=script&lang=ts"
export * from "./OptionsContainer.vue?vue&type=script&lang=ts"

import "./OptionsContainer.vue?vue&type=style&index=0&id=6c2ad046&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6c2ad046"

export default script